import dayjs from 'dayjs'

const InvoiceTemplate = ({ clinicRecord, patientRecord, medicalProfRecord, billingRecords, invoice, entity }) => {
  const formatDate = (date) => dayjs(date).format('DD MMM YYYY')

  return `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="utf-8">
      <title>META - CLINIC TAX INVOICE</title>
      <style>
        body {
          font-family: Arial, sans-serif;
          margin: 0;
          padding: 30px;
          color: #2c3e50;
          font-size: 13px;
          line-height: 1.4;
        }
        .header {
          display: flex;
          justify-content: space-between;
          margin-bottom: 25px;
          border-bottom: 2px solid #eee;
          padding-bottom: 15px;
        }
        .entity-name {
          font-size: 18px;
          font-weight: bold;
          color: #2c3e50;
        }
        .clinic-name {
          font-size: 16px;
          font-weight: bold;
          color: #2c3e50;
        }
        .invoice-title {
          text-align: right;
          font-size: 16px;
          font-weight: bold;
          color: #2c3e50;
        }
        .info-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 25px;
          margin-bottom: 25px;
        }
        .info-section {
          background: #f8f9fa;
          padding: 12px;
          border-radius: 4px;
          box-shadow: 0 1px 3px rgba(0,0,0,0.1);
          margin-bottom: 5px;
        }
        .info-section h3 {
          margin: 0 0 12px 0;
          color: #2c3e50;
          font-size: 14px;
          font-weight: 600;
        }
        table {
          width: 100%;
          border-collapse: collapse;
          margin: 12px 0;
          font-size: 12px;
        }
        th, td {
          border: 1px solid #e9ecef;
          padding: 8px;
          text-align: left;
        }
        th {
          background-color: #f8f9fa;
          font-weight: 600;
          color: #2c3e50;
          font-size: 12px;
        }
        tr:nth-child(even) {
          background-color: #f8f9fa;
        }
        .totals {
          width: 300px;
          margin-left: auto;
          background: #f8f9fa;
          padding: 12px;
          border-radius: 4px;
          box-shadow: 0 1px 3px rgba(0,0,0,0.1);
        }
        .totals table {
          margin-top: 0;
          font-size: 12px;
        }
        .totals td {
          border: none;
          padding: 6px 0;
        }
        .banking-details {
          margin-top: 25px;
          border-top: 1px solid #e9ecef;
          padding-top: 15px;
        }
        .footer {
          margin-top: 30px;
          text-align: center;
          font-size: 11px;
          color: #6c757d;
          border-top: 1px solid #e9ecef;
          padding-top: 15px;
        }
        p {
          margin: 4px 0;
          font-size: 13px;
        }
        strong {
          color: #2c3e50;
        }
      </style>
    </head>
    <body>
      <div class="header">
        <div class="entity-name">${entity.name} - ${clinicRecord.name}</div>
        <div class="invoice-title">INVOICE</div>
      </div>

      <div class="info-grid">
        <div class="info-section">
          <p>Practice number: ${clinicRecord.practiceNumber}</p>
          <p>${clinicRecord.physicalAddress}</p>
          <p>Contact number: ${clinicRecord.phoneNumber}</p>
          <p>Email address: ${clinicRecord.email}</p>
        </div>

        <div class="info-section">
          <p>Date of service: ${formatDate(invoice.bookingDate)}</p>
          <p>Invoice number: ${invoice.invoiceNo}</p>
          <p>Account number: ${patientRecord.billingId}</p>
        </div>
      </div>

      <div class="info-section">
        <h3>Bill to</h3>
        <p>${patientRecord.firstName} ${patientRecord.lastName}</p>
        <p>Medical aid name: ${patientRecord.medicalAid.name || ''}</p>
        <p>Medical aid number: ${patientRecord.medicalAid.number || ''}</p>
        <p>Account email: ${patientRecord.email || ''}</p>
        <p>Contact number: ${patientRecord.phoneNumber || ''}</p>
      </div>

      <div class="info-section">
        <h3>Patient details</h3>
        <table>
          <tr>
            <th>Full name</th>
            <th>Dependant number</th>
            <th>Date of birth</th>
            <th>Gender</th>
            <th>ID number</th>
          </tr>
          <tr>
            <td>${patientRecord.firstName} ${patientRecord.lastName}</td>
            <td>${patientRecord.medicalAid.dependantNumber || '00'}</td>
            <td>${patientRecord.dateOfBirth ? formatDate(patientRecord.dateOfBirth) : ''}</td>
            <td>${patientRecord.gender || ''}</td>
            <td>${patientRecord.idNo || ''}</td>
          </tr>
        </table>
      </div>

      <div class="info-section">
        <h3>Treating provider</h3>
        <table>
          <tr>
            <th>Full name</th>
            <th>MP number</th>
            <th>Practice number</th>
            <th>Place of service</th>
          </tr>
          <tr>
            <td>${medicalProfRecord.firstName} ${medicalProfRecord.lastName}</td>
            <td>${medicalProfRecord.extraData.mpNumber || ''}</td>
            <td>${clinicRecord.practiceNumber || ''}</td>
            <td>Consulting Room</td>
          </tr>
        </table>
      </div>

      <div class="info-section">
        <h3>Treatment details</h3>
        <table>
          <tr>
            <th>Code [Modifier]</th>
            <th>Name/Description </th>
            <th>NAPPI code</th>
            <th>Qty</th>
            <th>Total</th>
            <th>Medical Aid</th>
            <th>Patient</th>
          </tr>
          ${billingRecords
            ?.map(
              (item) => `
            <tr>
              <td>${item.code}</td>
              <td>${item.name}</td>
              <td>${item.nappiCode || ''}</td>
              <td>${item.qty}</td>
              <td>${item.total}</td>
              <td>${item.medicalAid}</td>
              <td>${item.patient}</td>
            </tr>
          `
            )
            .join('')}
        </table>
      </div>

      <div class="totals">
        <table>
          <tr>
            <td><strong>Medical Aid Due</strong></td>
            <td><strong>R ${
              billingRecords.reduce((acc, item) => acc + parseFloat(item.medicalAid), 0)?.toFixed(2) || '0.00'
            }</strong></td>
          </tr>
          <tr>
            <td><strong>Patient Due</strong></td>
            <td><strong>R ${
              billingRecords.reduce((acc, item) => acc + parseFloat(item.patient), 0)?.toFixed(2) || '0.00'
            }</strong></td>
          </tr>
          <tr>
            <td><strong>Total Due</strong></td>
            <td><strong>R ${
              billingRecords.reduce((acc, item) => acc + parseFloat(item.total), 0)?.toFixed(2) || '0.00'
            }</strong></td>
          </tr>
        </table>
      </div>
      
      <div class="footer">
        <p>Generated on ${formatDate(new Date())} at ${dayjs().format('HH:mm')}</p>
      </div>
    </body>
    </html>
  `
}

export default InvoiceTemplate
